type Scope = { id: string; rights: string[] };

export const AppAuth = {
	canAdd: (scopes: Scope[], currentScope: string) =>
		scopes.some(({ id, rights }) => id === currentScope && rights.includes('machine.edit')),
	canAddAny: (scopes: Scope[]) => scopes.some(({ rights }) => rights.includes('machine.edit'))
};
